export enum AvatarSize {
  xsmall = 1,
  small = 1.5,
  medium = 2,
  large = 2.5,
  mega = 5,
}

export const AvatarSizesOptions = {
  [AvatarSize.xsmall]: {
    size: AvatarSize.xsmall,
    border: '1px',
  },
  [AvatarSize.small]: {
    size: AvatarSize.small,
    border: '1px',
  },
  [AvatarSize.medium]: {
    size: AvatarSize.medium,
    border: '1.5px',
  },
  [AvatarSize.large]: {
    size: AvatarSize.large,
    border: '2px',
  },
  [AvatarSize.mega]: {
    size: AvatarSize.mega,
    border: '3px',
  },
};
